module.exports = __webpack_public_path__ + "img/savings-not-fixed.b2ea9241.svg";